import { render, staticRenderFns } from "./psych.vue?vue&type=template&id=16b5ee3a&scoped=true&"
import script from "./psych.vue?vue&type=script&lang=js&"
export * from "./psych.vue?vue&type=script&lang=js&"
import style0 from "./psych.vue?vue&type=style&index=0&id=16b5ee3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5ee3a",
  null
  
)

export default component.exports